import React, { useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Loader2 } from 'lucide-react';
import './CategorizationProgress.css';

export default function CategorizationProgress({ phase, progress }) {
  const dialog = useRef(null);
  useLayoutEffect(() => {
    if (!progress.active) return undefined;
    const node = dialog.current;
    const previous = document.activeElement;
    const siblings = [...document.body.children].filter(el => el !== node);
    const prior = siblings.map(el => [el, el.inert]);
    prior.forEach(([el]) => { el.inert = true; });
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    node.focus();
    const lock = e => {
      if (e.type === 'keydown' || !node.contains(e.target)) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (e.type === 'keydown') node.focus();
      }
    };
    const focus = e => { if (!node.contains(e.target)) node.focus(); };
    ['click', 'pointerdown', 'keydown'].forEach(type => document.addEventListener(type, lock, true));
    document.addEventListener('focusin', focus, true);
    return () => {
      prior.forEach(([el, inert]) => { el.inert = inert; });
      document.body.style.overflow = overflow;
      ['click', 'pointerdown', 'keydown'].forEach(type => document.removeEventListener(type, lock, true));
      document.removeEventListener('focusin', focus, true);
      if (previous?.isConnected) previous.focus();
    };
  }, [progress.active]);
  if (!progress.active) return progress.error ? (
    <div role="alert" className="m-4 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800">
      {progress.error}{' '}
      <button type="button" className="underline font-semibold" onClick={progress.retry} disabled={progress.recovering}>
        {progress.recovering ? 'Checking saved state...' : 'Retry / check status'}
      </button>
    </div>
  ) : null;
  const message = phase === 3
    ? 'AI is analyzing client responses, assigning valence categories, and saving the dropdown selections.'
    : 'AI is categorizing client responses into Coping/Learning Mechanisms and Thematic Domains, and saving the dropdown selections.';
  return createPortal(
    <div ref={dialog} tabIndex={-1} role="dialog" aria-modal="true" aria-labelledby={`categorization-title-${phase}`} aria-describedby={`categorization-description-${phase}`} aria-busy="true"
      data-testid="categorization-progress" className="insight-categorization-overlay" style={{ zIndex: 2147483647 }}>
      <div className="insight-categorization-card">
        <header className="insight-categorization-header">
          <p className="insight-categorization-brand">INSIGHT · INTELLIGENT ANALYSIS</p>
          <h2 id={`categorization-title-${phase}`}>AI Categorization in Progress</h2>
          <p className="insight-categorization-phase">Phase {phase} — {phase === 3 ? 'Client Views' : 'Client Aspirations'}</p>
        </header>
        <div className="insight-categorization-body">
          <div className="insight-categorization-spinner"><Loader2 aria-hidden="true" /></div>
          <div id={`categorization-description-${phase}`} role="status" aria-live="polite" aria-atomic="true">
            <p className="insight-categorization-message">{message}</p>
            <p className="insight-categorization-wait">Please wait until the process is complete.</p>
          </div>
          <div className="insight-categorization-track" aria-hidden="true"><span /></div>
        </div>
      </div>
    </div>, document.body);
}
